export default "__VITE_PUBLIC_ASSET__0c5a4b97__"